import React, { useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { confirmReturnedToPickupPoint } from './services';

import { setMessage } from '../toasts/toastSlice';
import { setOrdersModalConfig, setOrdersToReturnFilters } from './orderSlice';

import OrderCommentInput from '../common/_inputs/OrderComment';
import OrderModalWrapper from './OrderModalWrapper';
import { handleAxiosErrorMessage } from '../../utils';
import { NOTIFICATION_TYPES } from '../../config/consts/commons';
import { useTranslation } from 'react-i18next';

const OrdersToReturnModal = () => {
  const { t } = useTranslation(['system', 'button']);
  const { ordersToReturnFilters: filters, ordersModalConfig } = useSelector(
    (state) => state.orders
  );
  const { order } = ordersModalConfig;
  const [buttonLabel, setButtonLabel] = useState(
    t('confirm', { ns: 'button' })
  );

  const [comment, setComment] = useState('');

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSubmitError, setShowSubmitError] = useState(false);

  const dispatch = useDispatch();

  const handleSubmit = async () => {
    setShowSubmitError(false);

    const { id_order, order_code } = order;

    setIsSubmitting(true);
    try {
      const payload = {
        id_order,
        comment,
      };

      await confirmReturnedToPickupPoint(payload);

      resetModal();
      dispatch(setOrdersToReturnFilters({ ...filters }));

      dispatch(
        setMessage({
          body: t('ORDER_WITHDRAW_SUCCESS', {
            ns: 'system',
            order: order_code,
          }),
          type: NOTIFICATION_TYPES.SUCCESS,
        })
      );
    } catch (err) {
      const errorMessage = handleAxiosErrorMessage(err);
      setIsSubmitting(false);
      setButtonLabel(t('confirm_return', { ns: 'button' }));
      setShowSubmitError(true);

      dispatch(
        setMessage({
          body: t(errorMessage, { ns: 'system' }),
          type: NOTIFICATION_TYPES.ERROR,
        })
      );
    }
  };

  const resetModal = () => {
    const { show, ...rest } = ordersModalConfig;
    setButtonLabel(t('confirm', { ns: 'button' }));
    setIsSubmitting(false);
    setShowSubmitError(false);
    dispatch(setOrdersModalConfig({ ...rest, show: false }));
  };

  return (
    <OrderModalWrapper
      handleClose={resetModal}
      handleSubmit={handleSubmit}
      buttonLabel={buttonLabel}
      isSubmitting={isSubmitting}
      showSubmitError={showSubmitError}
    >
      <OrderCommentInput setComment={(payload) => setComment(payload)} />
    </OrderModalWrapper>
  );
};

export default OrdersToReturnModal;
